import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { homeEventsList } from '../services/General-service';

function MediaShell({ className, url, children }) {
    const href = typeof url === 'string' ? url.trim() : '';
    if (!href) {
        return <div className={className}>{children}</div>;
    }

    const isExternal = /^https?:\/\//i.test(href);
    if (isExternal) {
        return (
            <a className={className} href={href} target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        );
    }

    return (
        <Link className={className} to={href}>
            {children}
        </Link>
    );
}

function UpcomingEvents({ showupcomingevents, sectionTitle }) {
    const [images, setImages] = useState([]);

    useEffect(() => {
        if (!showupcomingevents) return;

        homeEventsList()
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setImages(
                    list
                        .map((item) => ({
                            id: item?.id,
                            src: item?.banner_image || item?.image || item?.thumbnail || '',
                            url: item?.url || '',
                        }))
                        .filter((item) => item.src)
                        .slice(0, 3)
                );
            })
            .catch((error) => {
                console.error('Error fetching upcoming events:', error);
                setImages([]);
            });
    }, [showupcomingevents]);

    if (!showupcomingevents || images.length === 0) return null;

    return (
        <div className="App">
            <div className="BreakPointContainer">
                <div className="CarouselSectionContainer upcoming-events">
                    <div className="SectionTitle">
                        <h1 className="m-t-0 m-b-15 text-left demi-bold">{sectionTitle || 'UPCOMING AND ONGOING EVENTS'}</h1>
                    </div>
                    <div className="upcoming-events-grid">
                        {images.map((event, index) => (
                            <MediaShell
                                className="upcoming-events-card"
                                url={event.url}
                                key={event.id || index}
                            >
                                <img src={event.src} alt="" />
                            </MediaShell>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpcomingEvents;
